/** @jsx jsx */
import React from 'react';
import { cssMap, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	icon: {
		display: 'inline-block',
		width: token('space.200'),
		height: token('space.200'),
		marginRight: token('space.100'),
	},
});

type Props = {
	url: string;
};

function ViewComponent(props: Props) {
	return <img css={styles.icon} alt="" src={`data:image/svg+xml;base64,${props.url}`} />;
}

export default ViewComponent;
